import Vue from 'vue'
import BriqPlugin from '@v/BriqPlugin.js'
import Vuelidate from 'vuelidate'
import VueCompositionApi from '@vue/composition-api'
import components from '@v/components.js'
import router from '@v/Router.js'
import '@v/registerGlobalComponents.js'
import store from '@v/store/store.js'

import apiClient from '@v/apiClient.js'
import SafeApiClient from '@v/SafeApiClient.js'
import '@v/styles.styl'
import { currencySymbol } from '@/helpers/intlFormatter.js'
import logEnvironmentDetails from '@v/logEnvDetails.js'
import UpsertDealService from './vue/inventory/deals/edit/UpsertDealService.js'
import FunnelSettingsService from './vue/settings/application/funnel/FunnelSettingsService.js'
import ImageService from './vue/util/ImageService.js'

Vue.use(BriqPlugin(store))
const envIsNotProduction = window.environment !== 'production'
if (envIsNotProduction) logEnvironmentDetails()

// A Vue instance can be used as en event bus, we can use the methods:
// $emit(name, payload) to emit an event
// $on(name, handler) to subscribe to an event
// $off(name, handler) to unsubscribe from an event
// for more info/examples: https://alligator.io/vuejs/global-event-bus/
const EventBus = new Vue()

Vue.use(VueCompositionApi)
Vue.use(Vuelidate)
Vue.prototype.$bus = EventBus

Vue.prototype.$bus.$on('token-expired', tokenExpired => {
  document.documentElement.style.overflow = tokenExpired ? 'hidden' : 'auto'
})

export default new Vue({
  el: '#vue-app',
  router,
  store,
  components,
  provide: {
    upsertDealService: new UpsertDealService(EventBus),
    imageService: new ImageService(EventBus),
    funnelSettingsService: new FunnelSettingsService(EventBus, new ImageService(EventBus)),
  },
})
